/**
 * f15.5: the external viewer's own root, mounted by `main.tsx` INSTEAD of the
 * application for `/artifact/<anything>`.
 *
 * Nothing of the application is here: no MSAL provider, no AuthBootstrap, no
 * session query, no shell. A recipient's browser therefore issues no API
 * request and no Entra redirect until a code is submitted (BR-F15.5-02).
 */

import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ExternalViewerPage } from './ExternalViewerPage';

/** `/artifact/<ref>` for any ref -- the gate renders identically for all of them. */
export const EXTERNAL_VIEWER_PATH = /^\/artifact\/[^/]+\/?$/;

export function isExternalViewerPath(pathname: string): boolean {
  return EXTERNAL_VIEWER_PATH.test(pathname);
}

export function ExternalViewerApp({ queryClient }: { queryClient: QueryClient }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/artifact/:ref" element={<ExternalViewerPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
